// import * as types from '../mutation-types'
import { getStore, setStore } from '@/utils/session'
import * as types from '../mutation-types'
import { GetSpreadFeedbackAuditInfo } from "@/api/my";
import { Toast } from 'vant'
import router from '@/router/index'
import utils from '@/utils/utils'

// initial state
const state = {
  tempOrderInfo: getStore('tempOrderInfo') ? getStore('tempOrderInfo') : null
}

// getters
const getters = {
  getTempOrderInfo: state => state.tempOrderInfo
}

// mutations
const mutations = {
  [types.SET_TEMP_ORDER_INFO](state, tempOrderInfo) {
    state.tempOrderInfo = tempOrderInfo
    setStore('tempOrderInfo', tempOrderInfo)
  }
}
// actions
const actions = {
  // 差价反馈按钮事件
  async feedbackBtnEvent({ dispatch, state, commit }, { readyTaskId = '', dataInfo = null, platform = '' }) {
    let SpreadAuditStatus = await dispatch('getSpreadFeedbackAuditInfo', readyTaskId)
    if ([0, 1, 2].includes(SpreadAuditStatus)) {
      router.push({
        name: "checkPeiceFeedback",
      });
    } else {
      commit('SET_TEMP_ORDER_INFO', {
        TaskID: readyTaskId,
        PlatformType: platform,
        ...dataInfo
      })
      router.push({
        name: "diffPeiceFeedback"
      });
    }
  },
  // 获取差价反馈审核结果接口
  getSpreadFeedbackAuditInfo({ state }, taskID) {
    return GetSpreadFeedbackAuditInfo({ taskID: taskID })
      .then((res) => {
        return res.Data.SpreadAuditStatus;
      })
      .catch((err) => {
        if (err.ErrMsg) {
          Toast(err.ErrMsg);
        }
      });
  },
}

export default {
  state,
  getters,
  actions,
  mutations
}
